import * as THREE from "three";

export function createGridTexture({
  size = 2048,
  cells = 10,
  background = "#f9f9f9",
  line = "rgba(90, 90, 90, 0.35)",
  lineWidth = 0.75,
  repeat = 5,
} = {}) {
  const canvas = document.createElement("canvas");
  canvas.width = size;
  canvas.height = size;

  const context = canvas.getContext("2d");
  context.fillStyle = background;
  context.fillRect(0, 0, size, size);
  context.strokeStyle = line;
  context.lineWidth = lineWidth;

  const step = size / cells;
  for (let index = 0; index <= cells; index += 1) {
    const position = Math.round(index * step) + 0.5;
    context.beginPath();
    context.moveTo(position, 0);
    context.lineTo(position, size);
    context.stroke();

    context.beginPath();
    context.moveTo(0, position);
    context.lineTo(size, position);
    context.stroke();
  }

  const texture = new THREE.CanvasTexture(canvas);
  texture.colorSpace = THREE.SRGBColorSpace;
  texture.wrapS = THREE.RepeatWrapping;
  texture.wrapT = THREE.RepeatWrapping;
  texture.repeat.set(repeat, repeat);
  texture.generateMipmaps = true;
  texture.minFilter = THREE.LinearMipmapLinearFilter;
  texture.magFilter = THREE.LinearFilter;
  texture.anisotropy = 1;

  return texture;
}
